<app-dialog [title]="data.title" (close)="dialogRef.close(false)">
    <ng-container dialogContent>
        <p [innerHTML]="data.message"></p>
    </ng-container>
    <ng-container dialogActions>
        <fui-button #buttonNo (clickEvent)="dialogRef.close(false)" [label]="dictionary?.system_no" height="mini">
        </fui-button>
        <fui-button (clickEvent)="dialogRef.close(true)" [label]="dictionary?.system_yes" height="mini" color="light">
        </fui-button>
    </ng-container>
</app-dialog>
